import { detectWebTV } from './detectWebTV';
import {
  SamsungAdsInfo,
  SamsungProductInfo,
  getSamsungAdsInfo,
  getSamsungInfo,
  resolveSamsungId,
} from './helpers/tizen';
import { LGInfo, getLGDeviceInfo, getLGUDID, resolveLGId } from './helpers/webos';

export type WebTVInfo = {
  isLoaded: boolean;
  vendor: string | null;
  osName: string | null;
  isSimulated: boolean;
  lg?: LGInfo;
  samsung?: SamsungProductInfo & SamsungAdsInfo;
  tvIdType?: 'tifa' | 'lgudid' | 'dpid' | null;
  rdid?: string | null;
  msid?: string | '';
};

let tvInfo: WebTVInfo = {
  isLoaded: false,
  vendor: null,
  osName: null,
  isSimulated: false,
  msid: '',
};

let isLoading = false;

export const loadWebTVInfo = async () => {
  if (isLoading || tvInfo.isLoaded) return;
  isLoading = true;

  const detection = detectWebTV();

  tvInfo.vendor = detection.vendor ?? null;
  tvInfo.osName = detection.osName ?? null;
  tvInfo.isSimulated = detection.simulated;

  if (!detection.isTV || detection.simulated) {
    tvInfo.isLoaded = true;
    isLoading = false;
    return;
  }

  if (detection.osName === 'webOS') {
    const deviceInfo = await getLGDeviceInfo();
    const lgudid = await getLGUDID();

    const { tvIdType, tvId } = resolveLGId(lgudid);

    tvInfo.lg = {
      ...(deviceInfo ?? {}),
      lgudid: lgudid ?? null,
      isLatEnabled: null,
    };

    tvInfo.tvIdType = tvIdType;
    tvInfo.rdid = tvId;
    tvInfo.msid = '1141276';
  }

  if (detection.osName === 'Tizen') {
    const productInfo = getSamsungInfo();
    const adsInfo = getSamsungAdsInfo();

    if (productInfo || adsInfo) {
      const { tvIdType, tvId } = resolveSamsungId(adsInfo?.tifa ?? null);

      tvInfo.samsung = {
        ...(productInfo ?? {}),
        ...(adsInfo ?? {}),
      };

      tvInfo.tvIdType = tvIdType;
      tvInfo.rdid = tvId;
      tvInfo.msid = 'G3202204027118';
    }
  }

  tvInfo.isLoaded = true;
  isLoading = false;
};

export const getWebTVInfo = (): WebTVInfo => tvInfo;
